import type {App} from 'constants/apps'
import type {Permission} from 'constants/permissions'
import {difference, isEmpty, castArray} from 'lodash'


export const hasPermissions = (userPermissions: (Permission | App)[], requiredPermissions: (Permission | App)[]) => (
  isEmpty(difference(castArray(requiredPermissions), userPermissions))
)
